import {
	AfterViewInit,
	Component,
	ElementRef,
	Input,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { ZkNotificationService } from '@zenklub/ng-ui';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { ApiService } from '../services/api.service';

@Component({
	selector: 'superset-embed',
	templateUrl: './superset-embed.component.html',
	styleUrls: ['./superset-embed.component.scss'],
})
export class SupersetEmbedComponent implements AfterViewInit {
	@ViewChild('supersetDiv') supersetDiv!: ElementRef;

	@Input()
	messageLoading: string;

	@Input('dashboard')
	dashboard: string;

	@Input() heightIframePx!: number;
	@Input() heightIframeVh!: number;
	@Input() organizationId!: number;
	loading = true;
	hasError = false;

	constructor(
		private readonly apiService: ApiService,
		private notificationService: ZkNotificationService
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.dashboard?.currentValue && !changes.dashboard?.firstChange) {
			this.loadSuperset();
		}
	}

	ngAfterViewInit(): void {
		this.loadSuperset();
	}

	private loadSuperset() {
		const config = Object.values(environment.superset.dashboards).find(
			(it) => it.id === this.dashboard
		);
		embedDashboard({
			id: this.dashboard,
			supersetDomain: environment.superset.domain,
			mountPoint: this.supersetDiv.nativeElement,
			fetchGuestToken: () => this.fetchGuestToken().toPromise(),
			dashboardUiConfig: {
				hideTitle: true,
				filters: config?.hideFilters
					? { expanded: false, visible: false }
					: undefined,
			},
		})
			.catch((err) => {
				console.error(err);
				this.hasError = true;
				this.loading = false;
				this.notificationService.showError(
					`Ocorreu um erro inesperado ao carregar seu dashboard de id '${this.dashboard}'. Por favor tente novamente.`
				);
			})
			.then(
				() => this.adjustIFrameSize(this.supersetDiv),
				(error) => {
					console.error(`Error adjusting iframe size`, error);
				}
			);
	}

	private fetchGuestToken() {
		return this.apiService
			.getEmbedTokenForSuperset(this.dashboard)
			.pipe(map((res) => res.token));
	}

	private async adjustIFrameSize(element: ElementRef) {
		element?.nativeElement
			.querySelector('iframe')
			.setAttribute('style', 'width: 100%; height: 100%');
		this.loading = false;
	}
}
